const customFormJsClass = 'js-custom-form';
const parentJsClass = customFormJsClass + '-parent';
const childJsClass = customFormJsClass + '-child';

const customFormElement = document.querySelector('.' + customFormJsClass);
let parentElements: HTMLInputElement[];
let childElements: HTMLElement[];

if (customFormElement) {
    parentElements = Array.from(customFormElement.querySelectorAll('.' + parentJsClass));
    childElements = Array.from(customFormElement.querySelectorAll('.' + childJsClass));

    updateChildElements();

    parentElements.forEach((parentElement) => {
        parentElement.addEventListener('change', () => {
            updateChildElements();
        });
    });
}

function updateChildElements () {
    if (!childElements) {
        return;
    }

    childElements.forEach((childElement) => {
        const parentElement = parentElements.find((parentElement) => parentElement.dataset.id === childElement.dataset.id);

        if (parentElement.checked) {
            childElement.style.display = 'initial';
        } else {
            childElement.style.display = 'none';
        }
    });
}